import { Unit, UnitPrefix, BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { Joule } from "./energy";
/**
 * The derived unit for power, radiant, flux ( <code>W</code> ).
 * One watt is equal to one joule per second.
 * It is named after the British scientist James Watt (1736-1819).
 */
export var Watt = UnitDivide.energyByDuration("Watt", Joule, BaseUnits.Second);
// Power
export var KiloWatt = UnitPrefix.Kilo("KiloWatt", Watt);
export var MegaWatt = UnitPrefix.Mega("MegaWatt", Watt);
export var GigaWatt = UnitPrefix.Giga("GigaWatt", Watt);
export var BtuPerHour = Unit.divideNumber("BtuPerHour", 3600.0, Unit.timesNumber("", 52752792631.0 / 50000000.0, Watt));
export var TonCooling = Unit.timesNumber("TonCooling", 12000.0, BtuPerHour);
export var KiloBtuPerHour = UnitPrefix.Kilo("KiloBtuPerHour", BtuPerHour);
export var HorsePower = Unit.timesNumber("HorsePower", 745.699872, Watt);
export var VoltAmpere = Unit.createAlternate("VoltAmpere", "VA", Watt);
//# sourceMappingURL=power.js.map